<template>

  <panel-navigation>

      <div v-if="showPreviewImage" @click.self="showPreviewImage = false;" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
          <div class="bg-white rounded-lg mx-6">

              <div class="">

                  <v-btn
                      class="float-right -mt-3 -mr-3"
                      fab
                      color="gray"
                      dark
                      x-small
                      elevation="0"
                      @click="showPreviewImage = false"
                      :ripple="false"
                      >
                      <v-icon >
                          mdi-close
                      </v-icon>
                  </v-btn>

                  <div class="text-center">
                      <img :src="previewImageUrl" style="max-height: 700px;" />
                  </div>

              </div>

          </div>
      </div>

      <div class="float-right mb-3">
          <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="addImage();" style="margin-top: -7px;">+ ADD IMAGE TEMPLATE</div>
      </div>

      <h1 class="text-lg font-semibold mb-3">Image Templates</h1>

      <div style="clear: both;"></div>

      <v-skeleton-loader v-if="fetchingImages" type="article, article, article"></v-skeleton-loader>

      <div class="dashboard-box" v-if="!fetchingImages && images.length == 0">
        <v-card
          class="pa-2"
          tile
        >
          <div class="p-3">

            <br /><br /><br /><br />

            <div class="dashboard-box-iconsquare">
              <div class="dashboard-box-icon-background"></div>
              <div class="dashboard-box-icon">
                <i class="mdi mdi-file-document-multiple-outline"></i>
              </div>
            </div>

            <div style="text-align: center;">
              <div class="pt-2 pb-2">
                <strong>No Personalization Images Yet</strong>
              </div>

              <div class="text-sm mb-4 text-gray-600">
                You have no images yet. Use our tools to add images.
              </div>

              <br />

              <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 inline-block rounded cursor-pointer" @click="addImage()" style="margin-top: -5px;"><i class="fa fa-plus mr-2"></i> CREATE IMAGE</div>
            </div>
            
            <br /><br /><br /><br /><br />
          </div>
        </v-card>
      </div>

      <template v-if="!fetchingImages && images.length > 0">

        <div>
          <div v-for="image in images" :key="image.id" class="lf-templates-item">
            <v-card
              class=""
              tile
            >
              <div style="padding: 15px;">
                <div class="lf-image-preview" style="text-align: center">
                  <img :src="image.preview_url" style="height: 120px; cursor: pointer; border: solid 1px #dee0e0;" @click="previewImage(image.preview_url)" />
                </div>

                <div style="clear: both;"></div>
              </div>

              <div style="float: right;">
                <v-menu
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      dark
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="ml-3"
                      color="grey darken-1"
                    >
                      <i class="mdi mdi-dots-vertical" style="font-size: 18px;"></i>
                    </v-btn>
                  </template>

                  <v-list class="table-menu-actions">
                    <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="copyImage(image)"><span class="table-menu-action-icon"><i class="fa fa-copy"></i></span> Duplicate</a></v-list-item-title></v-list-item>
                    <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="editImage(image)"><span class="table-menu-action-icon"><i class="fa fa-pen"></i></span> Edit</a></v-list-item-title></v-list-item>
                    <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="deleteImage(image)"><span class="table-menu-action-icon"><i class="fa fa-trash"></i></span> Delete</a></v-list-item-title></v-list-item>
                  </v-list>
                </v-menu>
              </div>

              <div style="color: #19233A; font-weight: bold; font-size: 14px; padding: 15px; padding-bottom: 0px;">{{  image.title  }}</div>

              <div style="color: #757B89; font-size: 12px; padding: 15px;">Last Edit {{ getLastUpdated(image.updated_at) }}</div>

              <div style="clear: both;"></div>
            </v-card>
          </div>
        </div>

        <div style="clear: both;"></div>

      </template>
  </panel-navigation>

</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios';
import PanelNavigation from '@/components/PanelNavigation.vue'
import MenuImageActions from '@/components/menus/menuImageActions.vue'
import DialogAddImage from '@/components/dialogs/images/addImage.vue'
import moment from 'moment-timezone'

export default {
  metaInfo () {
    return {
      title: "Personalization Images | " + this.$appName
    }
  },
  components: {
    PanelNavigation,
    MenuImageActions,
    DialogAddImage
  },
  data() {
    return {
      selectedIds: [],
      showPreviewImage: false,
      previewImageUrl: null
    }
  },
  computed: {
    ...mapState({
      me: state => state.me.me,
      images: state => state.personalization_images.images,
      fetchingImages: state => state.personalization_images.fetchingImages
    })
  },
  methods: {
    getLastUpdated(date) {
      // Dec 05, 2022
      return moment(String(date)).format('MMM DD, YYYY');
    },

    async bulkDelete() {
      await this.$store.dispatch('personalization_images/bulkDelete', {ids: this.selectedIds})
      this.$store.dispatch('personalization_images/fetch')
      this.selectedIds = []
    },

    async deleteImage(image) {
      await this.$store.dispatch('personalization_images/bulkDelete', {ids: [image.id]})
      this.$store.dispatch('personalization_images/fetch')
      this.selectedIds = []
    },

    getPreview(content) {
        return (content.length > 100) ? content.substring(0, 100) + "..." : content;
    },

    addImage() {
      window.location = '/image-editor/';
    },

    editImage(image) {
      window.location = '/image-editor/' + image.id;
    },

    async copyImage(image) {
      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/personalization-images/copy`, {
        id: image.id
      }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
      })

      window.location = '/image-editor/' + response.data.template.id;
    },

    previewImage(url) {
        this.showPreviewImage = true;
        this.previewImageUrl = url;
    },
  },
  created() {
    this.$store.state.personalization_images.fetchingImages = true
    this.$store.dispatch('personalization_images/fetch')
  },
}
</script>

<style lang="scss" scoped>

.styled-checkbox {
  position: absolute; // take it out of document flow
  opacity: 0; // hide it

  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
  }

  // Box.
  & + label:before {
    content: '';
    margin-right: 0px;
    display: inline-block;
    vertical-align: text-top;
    width: 20px;
    height: 20px;
    background: rgb(228, 228, 228);
  }

  // Box hover
  /*&:hover + label:before {
    background: #f35429;
  }*/
  
  // Box focus
  &:focus + label:before {
    
    border-width: 0;
  }

  // Box checked
  &:checked + label:before {
    background: #48bb78;
  }
  
  // Disabled state label.
  &:disabled + label {
    color: #b8b8b8;
    cursor: auto;
  }

  // Disabled box.
  &:disabled + label:before {
    box-shadow: none;
    background: #ddd;
  }

  // Checkmark. Could be replaced with an image
  &:checked + label:after {
    content: '';
    position: absolute;
    left: 5px;
    top: 9px;
    background: white;
    width: 2px;
    height: 2px;
    box-shadow: 
      2px 0 0 white,
      4px 0 0 white,
      4px -2px 0 white,
      4px -4px 0 white,
      4px -6px 0 white,
      4px -8px 0 white;
    transform: rotate(45deg);
  }
}

.btn-invite {
  background-color: #00ad9e;
}

table tbody tr {
  transition: all 0.1s linear;
}

table tbody tr:hover {
  background-color: rgb(245, 245, 245);
}

.v-list-item {
  min-height: 27px;
  font-size: 13px;
}

.lf-templates-item {
  float: left;
  width: 23%;
  // margin-top: 0px;
  margin-right: 2.6%;
  margin-bottom: 20px;
}

.lf-templates-item:nth-child(4n) {
  float: right;
  margin-right: 0px;
}

.lf-templates-text {
  clear: both; padding-top: 25px; padding-bottom: 25px; text-align: center; color: #19233A; font-size: 14px; height: 100px; vertical-align: middle;
}
</style>
